import { useEffect } from 'react';
import { getCrmChatSockJsUrl } from '@/config/chat-ws';
import { buildSessionUserTopic, parseSessionEvent } from '@/shared/model/session-event.model';
import { acquireCrmStompSharedConnection, onCrmStompSharedConnect, releaseCrmStompSharedConnection, subscribeCrmStompSharedTopic, } from '@/shared/ws/crmStompSharedClient';
/**
 * Subscribes to `/topic/session.user.{username}` on the shared CRM STOMP connection.
 */
export function useSessionUserTopicSubscription({ username, enabled = true, sockJsUrl = getCrmChatSockJsUrl(), onForceLogout, }) {
    useEffect(() => {
        const trimmed = username?.trim() ?? '';
        if (!enabled || !trimmed)
            return undefined;
        let topic;
        try {
            topic = buildSessionUserTopic(trimmed);
        }
        catch {
            return undefined;
        }
        acquireCrmStompSharedConnection(sockJsUrl);
        const unsubscribeTopic = subscribeCrmStompSharedTopic(topic, (frame) => {
            const event = parseSessionEvent(frame.body);
            if (!event || event.eventType !== 'FORCE_LOGOUT')
                return;
            onForceLogout?.({
                forcedBy: event.forcedBy,
                username: event.username,
            });
        });
        const detachConnect = onCrmStompSharedConnect(() => {
            /* topic re-subscribed automatically on shared reconnect */
        });
        return () => {
            detachConnect();
            unsubscribeTopic();
            releaseCrmStompSharedConnection();
        };
    }, [enabled, onForceLogout, sockJsUrl, username]);
}
